import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Order from './Pages/Order';
import OrderEntryPage from './Pages/OrderEntryPage';
// import Requests from './Pages/Requests.jsx';
import Inventory from './Pages/Inventory.jsx';
import SecMasterScreen from './Pages/SecMasterScreen.jsx';
import { AuthProvider } from './Context/AuthProvider.jsx';
import LoginPage from './Pages/LoginPage.jsx';
import ProtectedRoute from './Routes/ProtectedRoute.jsx';
import RoleProtectedRoute from './Routes/RoleProtectedRoute.jsx';
import Layout from './Component/Layout/Layout.jsx';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./Common/theme";
import FilterPopup from './Component/FilterPopup.jsx';
import SecMasterSearch from './Component/SecMasterComponents/SecMasterSearch.jsx';
import SessionRoute from './Routes/SessionRoute';
import BondLadderDetails from './Pages/BondLadderDetails.jsx';
import BondLadderPreview from './Pages/BondLadderPreview.jsx';
import AccountPositionExplorer from './Pages/AccountPositionExplorer.jsx';
import PortfolioRebalanceScreen from './Pages/PortfolioRebalanceScreen.jsx';
import { WebSocketProvider } from './Utils/WebSocketProvider.jsx';
import { GlobalProvider } from './Context/GlobalContext'; // Import the provider
import OrderPreviewScreen from './Pages/OrderPreviewScreen.jsx';
import YieldMatrixPage from './Pages/YieldMatrixPage.jsx';
import CounterParties from './Pages/CounterParties.jsx';
import QuickFixLogsPage from './Pages/QuickFixLogsPage..jsx';
import SessionAndUserManagement from './Pages/SessionAndUserManagement.jsx';
import MAInventory from './Pages/MAInventory.jsx';
import { USER_ROLES } from './Constants/AppConstants';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <AuthProvider>
        <WebSocketProvider>
          <Router>
            <GlobalProvider>
              <AppRoutes />
            </GlobalProvider>
          </Router>
        </WebSocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route element={<SessionRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/inventory" element={<Inventory />}/>
          <Route path="/sec-master" element={<SecMasterScreen />}/>
          <Route path="/watchlist" element={<MAInventory />}/>
          <Route path="/ma-inventory" element={<Navigate to="/watchlist" replace />}/>
          <Route path="/order" element={<Order />}/>
          <Route path="/order-entry" element={<OrderEntryPage />}/>
          <Route path='/search-inventory' element={<FilterPopup />} />
          <Route path='/search-sec-master' element={<SecMasterSearch />} />
          <Route path="/bond-ladder-detail" element={<BondLadderDetails />}/>
          <Route path="/bond-ladder-preview" element={<BondLadderPreview />}/>
          <Route path="/inventory/yield-table" element={<YieldMatrixPage />} />
          <Route path="/counter-parties" element={<CounterParties />} />
          <Route path="/quickfix-logs" element={<QuickFixLogsPage />} />
          
          {/* PMS-only routes - requires isPms flag enabled */}
          <Route element={<RoleProtectedRoute requiresPms={true} />}>
            <Route path="/account-positions" element={<AccountPositionExplorer />}/>
            <Route path="/portfolio-rebalance" element={<PortfolioRebalanceScreen />}/>
            <Route path="/portfolio-rebalance/order-preview" element={<OrderPreviewScreen />} />
            <Route path="/portfolio-rebalance/portfolio-play" element={<OrderPreviewScreen />} />
          </Route>

          {/* ADMIN-only routes - requires ADMIN role */}
          <Route element={<RoleProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]} />}>
            <Route path="/admin" element={<SessionAndUserManagement />} />
            <Route path="/session-user-management" element={<Navigate to="/admin" replace />} />
            <Route path="/edi-file-process-management" element={<Navigate to="/admin?tab=2" replace />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
export default App;
